import { Alert, VFlow } from 'bold-ui'
import { AtendimentoProfissional } from 'graphql/types.generated'
import React from 'react'
import { AcompanhamentoVulnerabilidadeSection } from 'view/atendimentos/detail/soap/aside/acompanhamento-vulnerabilidade/AcompanhamentoVulnerabilidadeSection'
import { IdadeGestacionalAcompanhamentoPreNatal } from 'view/atendimentos/detail/soap/aside/pre-natal/model-acompanhamentoPreNatal'

import { ExternalPaths } from '../model-acompanhamentoPreNatal'
import { AutorreferidasCard } from './AutorreferidasCard'
import { ConsultasGestacaoCard } from './ConsultasGestacaoCard'
import { ExamesPreNatalCard } from './ExamesPreNatalCard'
import { InformacoesGestacaoAtualCard } from './InformacoesGestacaoAtualCard'
import { ListaProblemasCondicoesCard } from './ListaProblemasCondicoesCard'
import { MedicamentosEmUsoCard } from './MedicamentosEmUsoCard'
import { MedicoesGestacaoCard } from './MedicoesGestacaoCard'
import { ProximosAgendamentosCard } from './ProximosAgendamentosCard'
import { VacinacaoGestacaoCard } from './VacinacaoGestacaoCard'
import { VisitasDomiciliaresGestacaoCard } from './VisitasDomiciliaresGestacaoCard'

interface InformacoesGestacaoTabContentProps {
  cidadaoId: ID
  prontuarioId: ID
  atendimentoId: ID
  dataReferencia: Instant
  loading: boolean
  dum: Date
  idadeGestacional: IdadeGestacionalAcompanhamentoPreNatal
  dataInicioGestacao: Date
  dppEcografica: Date
  atendimentosProfUltimaGestacao: AtendimentoProfissional[]
  medicoesPath: string
  externalPaths: ExternalPaths
  isVisualizacaoProntuario: boolean
}

export const InformacoesGestacaoTabContent = (props: InformacoesGestacaoTabContentProps) => {
  const {
    cidadaoId,
    prontuarioId,
    atendimentoId,
    loading,
    dataReferencia,
    dum,
    idadeGestacional,
    dataInicioGestacao,
    dppEcografica,
    atendimentosProfUltimaGestacao,
    medicoesPath,
    externalPaths,
    isVisualizacaoProntuario,
  } = props

  return (
    <VFlow>
      {!isVisualizacaoProntuario && (
        <Alert type='info'>Os dados inseridos no atendimento atual só serão exibidos no próximo atendimento.</Alert>
      )}
      <InformacoesGestacaoAtualCard
        cidadaoId={cidadaoId}
        atendimentoId={atendimentoId}
        loading={loading}
        dum={dum}
        idadeGestacional={idadeGestacional}
        dataInicioGestacao={dataInicioGestacao}
        dppEcografica={dppEcografica}
        atendimentosProfUltimaGestacao={atendimentosProfUltimaGestacao}
        dataReferencia={dataReferencia}
      />
      <AcompanhamentoVulnerabilidadeSection
        cidadaoId={cidadaoId}
        dataReferencia={dataReferencia}
        isAcompanhamentoPreNatal
      />
      <MedicoesGestacaoCard
        prontuarioId={prontuarioId}
        dataInicioGestacao={dataInicioGestacao}
        atendimentosProfUltimaGestacao={atendimentosProfUltimaGestacao}
        medicoesPath={medicoesPath}
      />
      <MedicamentosEmUsoCard prontuarioId={prontuarioId} />
      <ListaProblemasCondicoesCard prontuarioId={prontuarioId} dataInicioGestacao={dataInicioGestacao} />
      <AutorreferidasCard cidadaoId={cidadaoId} />
      <ConsultasGestacaoCard
        cidadaoId={cidadaoId}
        atendimentoId={atendimentoId}
        dataInicioGestacao={dataInicioGestacao}
        historicoPath={externalPaths.historicoPath}
      />
      <VacinacaoGestacaoCard
        dataInicioGestacao={dataInicioGestacao}
        vacinacaoPath={externalPaths.vacinacaoPath}
        loading={loading}
        prontuarioId={prontuarioId}
      />
      <ExamesPreNatalCard prontuarioId={prontuarioId} dataInicioGestacao={dataInicioGestacao} loading={loading} />
      <VisitasDomiciliaresGestacaoCard
        cidadaoId={cidadaoId}
        dataInicioGestacao={dataInicioGestacao}
        historicoPath={externalPaths.historicoPath}
      />
      <ProximosAgendamentosCard cidadaoId={cidadaoId} agendamentosPath={externalPaths.agendamentosPath} />
    </VFlow>
  )
}
